<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <md-toolbar md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
        <div class="md-toolbar-section-start">
          <!-- <h3 class="md-title">{{ $route.name }}</h3> -->
        </div>
        <div class="md-toolbar-section-end">
          <md-button
            class="md-just-icon md-simple md-round md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>

          <div class="md-collapse" :class="{ 'off-canvas-sidebar': responsive }">
            <md-list>
              <md-list-item href="/dashboard">
                <md-icon>dashboard</md-icon>
                元学
              </md-list-item>
              <md-list-item href="javascript:;" @click="$router.push({ name: 'Register' })">
                <md-icon>person_add</md-icon>
                注 册
              </md-list-item>

              <md-list-item href="javascript:;" @click="gotoHelp">
                <a href="http://meta.docs.icubespace.com/#/" target="_blank">
                  <i
                    style="
                      margin-right: 3px;
                      max-width: 20px;
                      font-size: 1.15rem !important;
                      margin-left: 0;
                    "
                  >
                    <img :src="require('@/assets/img/help.png')" width="20" height="20" alt="" />
                  </i>
                  帮助中心
                </a>
                <!-- <md-icon>fingerprint</md-icon> -->
              </md-list-item>

              <md-list-item href="javascript:;" @click="versionDialogVisible = true">
                <md-icon>campaign</md-icon>
                <!-- contactUs -->
                <!-- <i style="margin-right: 3px;  max-width: 20px; font-size: 1.15rem !important; margin-left: 0;">
                 <img :src="require('@/assets/img/contactUs.png')"  width="20" height="20" alt="">
                </i> -->
                更新公告
              </md-list-item>

              <!-- <md-list-item href="javascript:;"  @click="$router.push({ name: 'Registers' })">
            
                                <md-icon style="padding-top:3px;">feedback</md-icon>
应用介绍    
      
              </md-list-item> -->
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>
    <v-dialog
      v-model="versionDialogVisible"
      scrollable
      persistent
      :overlay="false"
      max-width="80%"
      transition="dialog-transition"
    >
      <v-card>
        <iframe
          src="http://meta.docs.icubespace.com/#/version/20240117"
          frameborder="0"
          style="width: 100%; height: 600px"
        ></iframe>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="versionDialogVisible = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"
      >
        <div class="container md-offset">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <footer class="footer">
          <div class="container md-offset">
            <nav>
              <ul>
                <li>
                  <router-link :to="{ path: '/dashboard' }">首页</router-link>
                </li>
                <li>
                  <a href="#"> 元学 </a>
                </li>
                <li>
                  <a href="#"> 联盟院校 </a>
                </li>
                <li>
                  <a href="#"> 服务企业 </a>
                </li>
                <li>
                  <a href="#"> 合作伙伴 </a>
                </li>
              </ul>
            </nav>
            <div class="copyright text-center">
              &copy; {{ new Date().getFullYear() }} <a href="#" target="_blank">元学</a><a
                href="http:/www.icubespace.com"
                target="_blank"
                ></a
              >
              <!-- <a href="https://prod.meta.icubespace.com" target="_blank">元世界虚拟仿真教学App</a>,
              <a href="https://prod.meta.icubespace.com" target="_blank">MetaStation</a>,
              <a href="https://prod.meta.icubespace.com" target="_blank">可交互的数字化课程应用</a> -->
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black',
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
      versionDialogVisible: false,
      // aboutDialog: false,
    };
  },
  computed: {
    setBgImage() {
      let images = {
        Login: './img/login.jpg',
        weixin: './img/login.jpg',
        Register: './img/register.jpg',
        Lock: './img/lock.jpg',
      };
      return {
        backgroundImage: `url(${images[this.$route.name]})`,
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  methods: {
    // goto(){
    //   return window.location.origin+'/about'
    // },
    gotoHelp() {
      // var NewUrl = 'https://meta.icubespace.com/docs/#/' ;
      //  window.open(NewUrl,'newindow','height=600,width=900,top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no');
    },
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle('nav-open');
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove('nav-open');
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    showVersionRecord() {},
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.md-collapse {
  z-index: 0;
}
.md-toolbar.md-toolbar-absolute {
  z-index: 1000 !important;
}

</style>
